module.exports = __webpack_public_path__ + "static/media/icon-widget-open.bc5a13a7.svg";